'use client';

import { useCuratorBroadcastSubscriber } from './curatorQuerySyncChannel';

export const CuratorBroadcastInitializer = () => {
  useCuratorBroadcastSubscriber();

  return null;
};
